export default "__VITE_ASSET__7QuvyWIK__"